import React from 'react';
import { Card, Typography } from 'antd';

const { Title, Paragraph } = Typography;

const Home = () => (
  <div style={{ maxWidth: 900, margin: '0 auto' }}>
    <Card style={{ borderRadius: 12 }}>
      <Title level={2} style={{ marginBottom: 8 }}>
        Olá, seja bem vindo(a) à Fisicore
      </Title>
      <Paragraph style={{ fontSize: 16, color: 'var(--text-secondary)' }}>
        Estamos felizes em ter você aqui.
      </Paragraph>
    </Card>
  </div>
);

export default Home;
